var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgPreviousWithTextIcon = function SvgPreviousWithTextIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 20 20"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#4D5B5A",
    d: "M17.875 8.866H6.253a.187.187 0 0 1-.187-.187v-2.25a.75.75 0 0 0-1.283-.532L1.222 9.459a.75.75 0 0 0 0 1.064L4.806 14.1a.749.749 0 0 0 1.282-.525v-2.25a.187.187 0 0 1 .165-.21h11.622a1.125 1.125 0 0 0 0-2.249"
  })));
};
export { SvgPreviousWithTextIcon as ReactComponent };